var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 31,
    viewBox: "0 0 68 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OMNI HUB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 3H21.0082V9.99179H28V3Z",
    fill: "url(#paint0_linear_1107_10917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0083 3H14.0165V9.99179H21.0083V3Z",
    fill: "url(#paint1_linear_1107_10917)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9836 3H6.99176V9.99179H13.9836V3Z",
    fill: "url(#paint2_linear_1107_10917)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9918 3H0V9.99179H6.9918V3Z",
    fill: "url(#paint3_linear_1107_10917)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9673 10.0244H20.9755V17.0162H27.9673V10.0244Z",
    fill: "url(#paint4_linear_1107_10917)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0083 10.0244H14.0165V17.0162H21.0083V10.0244Z",
    fill: "url(#paint5_linear_1107_10917)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9836 10.0244H6.99176V17.0162H13.9836V10.0244Z",
    fill: "url(#paint6_linear_1107_10917)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9918 9.99121H0V16.983H6.9918V9.99121Z",
    fill: "url(#paint7_linear_1107_10917)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24.0088H21.0082V31.0006H28V24.0088Z",
    fill: "url(#paint8_linear_1107_10917)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0083 24.0088H14.0165V31.0006H21.0083V24.0088Z",
    fill: "url(#paint9_linear_1107_10917)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9836 24.0088H6.99176V31.0006H13.9836V24.0088Z",
    fill: "url(#paint10_linear_1107_10917)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9918 24.0088H0V31.0006H6.9918V24.0088Z",
    fill: "url(#paint11_linear_1107_10917)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.9834H21.0082V23.9752H28V16.9834Z",
    fill: "url(#paint12_linear_1107_10917)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0083 17.0166H14.0165V24.0084H21.0083V17.0166Z",
    fill: "url(#paint13_linear_1107_10917)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9836 16.9834H6.99176V23.9752H13.9836V16.9834Z",
    fill: "url(#paint14_linear_1107_10917)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9918 17.0166H0V24.0084H6.9918V17.0166Z",
    fill: "url(#paint15_linear_1107_10917)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9551 28H40.5547V24.1328H36.6055V28H35.1992V19.4336H36.6055V22.9375H40.5547V19.4336H41.9551V28ZM50.9492 19.4336V24.9766C50.9492 25.5742 50.8223 26.1094 50.5684 26.582C50.3184 27.0547 49.9395 27.4297 49.4316 27.707C48.9238 27.9805 48.2852 28.1172 47.5156 28.1172C46.418 28.1172 45.582 27.8301 45.0078 27.2559C44.4375 26.6777 44.1523 25.9102 44.1523 24.9531V19.4336H45.5586V24.8301C45.5586 25.5449 45.7266 26.0723 46.0625 26.4121C46.3984 26.752 46.9004 26.9219 47.5684 26.9219C48.0293 26.9219 48.4043 26.8418 48.6934 26.6816C48.9863 26.5176 49.2012 26.2793 49.3379 25.9668C49.4785 25.6504 49.5488 25.2695 49.5488 24.8242V19.4336H50.9492ZM53.1406 19.4336H55.6895C56.7949 19.4336 57.6289 19.5938 58.1914 19.9141C58.7539 20.2344 59.0352 20.7871 59.0352 21.5723C59.0352 21.9004 58.9766 22.1973 58.8594 22.4629C58.7461 22.7246 58.5801 22.9414 58.3613 23.1133C58.1426 23.2812 57.873 23.3945 57.5527 23.4531V23.5117C57.8848 23.5703 58.1797 23.6738 58.4375 23.8223C58.6992 23.9707 58.9043 24.1836 59.0527 24.4609C59.2051 24.7383 59.2812 25.0977 59.2812 25.5391C59.2812 26.0625 59.1562 26.5078 58.9062 26.875C58.6602 27.2422 58.3066 27.5215 57.8457 27.7129C57.3887 27.9043 56.8457 28 56.2168 28H53.1406V19.4336ZM54.5469 22.9668H55.8945C56.5312 22.9668 56.9727 22.8633 57.2188 22.6562C57.4648 22.4492 57.5879 22.1465 57.5879 21.748C57.5879 21.3418 57.4414 21.0488 57.1484 20.8691C56.8594 20.6895 56.3984 20.5996 55.7656 20.5996H54.5469V22.9668ZM54.5469 24.1035V26.8223H56.0293C56.6855 26.8223 57.1465 26.6953 57.4121 26.4414C57.6777 26.1875 57.8105 25.8438 57.8105 25.4102C57.8105 25.1445 57.75 24.9141 57.6289 24.7188C57.5117 24.5234 57.3184 24.373 57.0488 24.2676C56.7793 24.1582 56.416 24.1035 55.959 24.1035H54.5469Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9434 8.70508C42.9434 9.36523 42.8594 9.9668 42.6914 10.5098C42.5273 11.0488 42.2793 11.5137 41.9473 11.9043C41.6152 12.291 41.1992 12.5898 40.6992 12.8008C40.1992 13.0117 39.6133 13.1172 38.9414 13.1172C38.2578 13.1172 37.6641 13.0117 37.1602 12.8008C36.6602 12.5898 36.2441 12.2891 35.9121 11.8984C35.584 11.5078 35.3379 11.041 35.1738 10.498C35.0098 9.95508 34.9277 9.35352 34.9277 8.69336C34.9277 7.81055 35.0723 7.04102 35.3613 6.38477C35.6543 5.72461 36.0977 5.21289 36.6914 4.84961C37.2891 4.48242 38.043 4.29883 38.9531 4.29883C39.8438 4.29883 40.584 4.48047 41.1738 4.84375C41.7637 5.20703 42.2051 5.71875 42.498 6.37891C42.7949 7.03516 42.9434 7.81055 42.9434 8.70508ZM36.4043 8.70508C36.4043 9.36523 36.4941 9.9375 36.6738 10.4219C36.8535 10.9023 37.1289 11.2734 37.5 11.5352C37.875 11.793 38.3555 11.9219 38.9414 11.9219C39.5312 11.9219 40.0117 11.793 40.3828 11.5352C40.7539 11.2734 41.0273 10.9023 41.2031 10.4219C41.3789 9.9375 41.4668 9.36523 41.4668 8.70508C41.4668 7.70117 41.2656 6.91602 40.8633 6.34961C40.4648 5.7793 39.8281 5.49414 38.9531 5.49414C38.3672 5.49414 37.8848 5.62305 37.5059 5.88086C37.1309 6.13867 36.8535 6.50781 36.6738 6.98828C36.4941 7.46484 36.4043 8.03711 36.4043 8.70508ZM48.4805 13L46.0137 5.8457H45.9609C45.9727 6.00586 45.9863 6.22461 46.002 6.50195C46.0176 6.7793 46.0312 7.07617 46.043 7.39258C46.0547 7.70898 46.0605 8.01172 46.0605 8.30078V13H44.7832V4.43359H46.7578L49.1309 11.2715H49.166L51.6211 4.43359H53.5898V13H52.248V8.23047C52.248 7.96875 52.252 7.68555 52.2598 7.38086C52.2715 7.07617 52.2832 6.78711 52.2949 6.51367C52.3105 6.24023 52.3223 6.02148 52.3301 5.85742H52.2832L49.7227 13H48.4805ZM62.9941 13H61.2656L57.0703 6.16211H57.0176C57.0332 6.39258 57.0469 6.63672 57.0586 6.89453C57.0742 7.15234 57.0859 7.41797 57.0938 7.69141C57.1055 7.96484 57.1152 8.24219 57.123 8.52344V13H55.8457V4.43359H57.5625L61.752 11.2246H61.793C61.7852 11.0254 61.7754 10.7969 61.7637 10.5391C61.752 10.2812 61.7402 10.0156 61.7285 9.74219C61.7207 9.46484 61.7148 9.19727 61.7109 8.93945V4.43359H62.9941V13ZM65.2441 13V4.43359H66.6504V13H65.2441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1107_10917",
    x1: 21.0163,
    y1: 3.03778,
    x2: 27.9655,
    y2: 9.98691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1107_10917",
    x1: 14.0255,
    y1: 9.98438,
    x2: 20.9713,
    y2: 3.03528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1107_10917",
    x1: 7.02954,
    y1: 3.03775,
    x2: 13.9786,
    y2: 9.98684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1107_10917",
    x1: 0.0385699,
    y1: 9.98438,
    x2: 6.98441,
    y2: 3.03528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1107_10917",
    x1: 27.9638,
    y1: 10.031,
    x2: 21.0148,
    y2: 16.9801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1107_10917",
    x1: 14.0272,
    y1: 16.9777,
    x2: 20.973,
    y2: 10.0285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1107_10917",
    x1: 7.02954,
    y1: 10.0326,
    x2: 13.9786,
    y2: 16.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1107_10917",
    x1: 6.98517,
    y1: 16.9763,
    x2: 0.0360774,
    y2: 10.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1107_10917",
    x1: 21.0171,
    y1: 30.9636,
    x2: 27.9663,
    y2: 24.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1107_10917",
    x1: 14.0247,
    y1: 24.0202,
    x2: 20.9705,
    y2: 30.9661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1107_10917",
    x1: 7.03033,
    y1: 30.9637,
    x2: 13.9795,
    y2: 24.0178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1107_10917",
    x1: 0.0377492,
    y1: 24.0202,
    x2: 6.98359,
    y2: 30.9661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1107_10917",
    x1: 27.9671,
    y1: 23.9686,
    x2: 21.018,
    y2: 17.0195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1107_10917",
    x1: 14.0255,
    y1: 17.0239,
    x2: 20.9713,
    y2: 23.9732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1107_10917",
    x1: 7.02954,
    y1: 23.967,
    x2: 13.9786,
    y2: 17.0179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1107_10917",
    x1: 6.98517,
    y1: 17.0231,
    x2: 0.0360778,
    y2: 23.9724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFFF3B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFFF3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CFFF3B",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CFFF3B",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#CFFF3B",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#CFFF3B",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#CFFF3B",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#CFFF3B",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#CFFF3B",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#CFFF3B",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFFF3B",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFFF3B",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDefault);
export default __webpack_public_path__ + "static/media/logoDefault.6b63f0a45ecabafe0340725cfaef7bff.svg";
export { ForwardRef as ReactComponent };